import "./Products.module.css";
import ProductionHeader from "@/reusable_sections/Header";
import UnleashYourAcademicVoice from "./sections/UnleashYourAcademicVoice";
import EngineeringExcellence from "./sections/EngineeringExcellence";
import SafetyInEveryMile from "./sections/SafetyInEveryMile";
import PiedDePage from "@/reusable_sections/Footer";
export default function ProductsPage() {
  return <div>
      <ProductionHeader />
      <UnleashYourAcademicVoice />
      <EngineeringExcellence />
      <SafetyInEveryMile />
      <PiedDePage />
    </div>;
}